import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function PrivateRoute({ redirectPath = '/', children }) {
    const idUsuario = localStorage.getItem("idUsuario");
  if (idUsuario==null) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
}

export default PrivateRoute;